import { useContext, useState } from "react";
import { Button } from "../tailwind/button";
import { CustomerContext } from "../../providers";
import { Heading } from "../tailwind/heading";
import { api } from "../../api";

export const ChoosePlan = () => {
  const { customer } = useContext(CustomerContext);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="flex flex-col justify-center items-center h-[70vh]">
      {!customer.isSubscribed && (
        <Button
          loading={isLoading}
          onClick={async () => {
            setIsLoading(true);
            const checkoutUrl = await api.createStripeCheckoutSession({
              customerId: customer.id,
            });
            window.open(checkoutUrl, "_self");
            setIsLoading(false);
          }}
        >
          Go to checkout
        </Button>
      )}
      {customer.isSubscribed && (
        <Heading>You are subscribed to Simio 🎉</Heading>
      )}
    </div>
  );
};
